var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-text-field", {
    ref: "input",
    staticClass: "mt-1",
    attrs: { dense: "", "hide-details": "" },
    on: {
      focus: function ($event) {
        _vm.focused = true
      },
      blur: function ($event) {
        _vm.focused = false
      },
      change: function ($event) {
        return _vm.apply()
      },
    },
    scopedSlots: _vm._u(
      [
        !_vm.focused
          ? {
              key: "append-outer",
              fn: function () {
                return [
                  _vm.showClearIcon
                    ? _c(
                        "v-icon",
                        {
                          staticClass: "pointer",
                          attrs: {
                            color: !_vm.clearIconHovered ? "green" : "red",
                          },
                          on: {
                            mouseenter: function ($event) {
                              _vm.clearIconHovered = true
                            },
                            mouseleave: function ($event) {
                              _vm.clearIconHovered = false
                            },
                            click: function ($event) {
                              return _vm.clear()
                            },
                          },
                        },
                        [_vm._v("mdi-filter-remove")]
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            }
          : null,
      ],
      null,
      true
    ),
    model: {
      value: _vm.internalValue,
      callback: function ($$v) {
        _vm.internalValue = typeof $$v === "string" ? $$v.trim() : $$v
      },
      expression: "internalValue",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }